(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["cart-Drawer"]) return;
  try {
    
window.SectionCartDrawer = (function(){
function SectionCartDrawer() {
  this._run();
}

SectionCartDrawer.prototype = {
  _run: function() {
    if(!disable_cartDrawer){
      var _add_to_cart = jQuery('.jq-cart-add-product');

      _add_to_cart.submit(function () {
        $('#add-to-cart-error').html('');
        jQuery('.btn-add-tocart').prop('disabled', true);
        jQuery('.btn-add-tocart .btn-progress').animate({ width: '30%'}, 250);

        VastaShop.Cart.addItem(jQuery(this).serialize()).then(function (prod, status) {
          if ('success' == status) {
            VastaShop.Cart.getAllItems().then(function(cart, status){
              if ('success' === status) {
                jQuery('.btn-add-tocart .btn-progress').animate({ width: '100%'}, 250, function(){
                    jQuery(this).css('width', '0').show();
                });

                VastaShop.Cart.current = cart;

                jQuery('.cupom-text').show();
                render_cart_drawer(VastaShop.Cart.current, jQuery('.list-products'), 0,'');

                update_shipping_bar(cart.total_price,cart.item_count);

                jQuery('.btn-add-tocart').prop('disabled', false);
                jQuery('body').addClass('cart-drawer-open cart-open');
                inventoryControl(prod.id);
              }
            }).catch(function(err) {
              console.log(err);
            });
          }
        }).catch(function(err) {
          if (err.status === 422) {
            var product_variants = $('#all-product-variants'),
                max_allowed = parseInt($('option:selected', product_variants).data('inventory')),
                variant_in_cart = VastaShop.Cart.current.items.filter(function(e){
                  return e.id == product_variants.val();
                }),
                quantity_limit_message;

            jQuery('.btn-add-tocart .btn-progress').animate({ width: '100%'}, 250, function(){
              jQuery(this).css('width', '0').show();
              $('.btn-add-tocart').attr('disabled', false);
            });
            
            if (variant_in_cart.length > 0) {
              quantity_limit_message = max_allowed - variant_in_cart[0].quantity;

              if (quantity_limit_message > 0) {
                quantity_limit_message = 'You can only add ' + quantity_limit_message + (quantity_limit_message != 1 ? ' units of this product variants.': 'unit of this product variant.');
              } else {
                quantity_limit_message = 'This variant can\'t be added anymore';
              }

              $('#add-to-cart-error').html( quantity_limit_message );
            }
          } else {
            throw err;
          }
        });

        return false;
      });
    }

    $('.list-products').on('click','.cart-product-wrapper',function(){
      if($(this).find('.jq-plus-cart-item').attr('disabled') == 'disabled'){
          $(this).find('.jq-plus-cart-item').removeAttr('disabled');
      }
    });

    if (!jQuery('body').hasClass('template-cart')) {
      jQuery('.list-products').click('.jq-minus-cart-item', function (e) {
        var item = jQuery(e.target).eq(0);

        if (item.hasClass('jq-plus-cart-item')) {
            plusItem(item, '.input-qtd');
        } else if (item.hasClass('jq-minus-cart-item')) {
            minusItem(item, '.input-qtd');
        } else if (item.hasClass('bt-remove-cart')){
          removeItem('.jq-remove-cart-item', '#jq-cart-item-', '.jq-total-price', item.attr('name'), item);
          return false;
        }
      });

      jQuery('.list-products').on('submit', '.jq-qtd-item-cart', function(e){
        var data = $(this).serializeArray();
        var OlD = $(this).find('.input-qtd').prop('defaultValue');

        $('#CartDrawer form').attr('disabled', 'disabled');

        VastaShop.Cart.change(data).then(function(cart){
          VastaShop.Cart.current = cart;
          render_cart_drawer( cart, jQuery('.list-products'),OlD, data[0].value.split(':')[0] );
          inventoryControl(data[0].value.split(':')[0]);
        }).catch(function(err) {
            console.log(err);
        });

        return false;
      });
    }

    if (!jQuery('body').hasClass('template-cart')){
      jQuery('.list-products').on('change ', '.input-qtd', function (e) {
        var input_qtd = jQuery(this).eq(0),
            item = jQuery(e.target).eq(0);

        if(input_qtd.val() < 1){
          input_qtd.val(1);
        }

        if(input_qtd.val() >= parseInt(input_qtd.attr('data-max')) && parseInt(input_qtd.attr('data-max')) != -1){
          input_qtd.val(parseInt(input_qtd.attr('data-max')));
          input_qtd.parent().find('.jq-minus-cart-item').removeAttr('disabled');
        }else if(input_qtd.val() < parseInt(input_qtd.attr('data-max')) && parseInt(input_qtd.attr('data-max')) != -1){
          input_qtd.parent().find('.jq-plus-cart-item').removeAttr('disabled');
          input_qtd.parent().find('.jq-minus-cart-item').removeAttr('disabled');
        }

        jQuery('.list-products').trigger('submit');
      });
    }

    jQuery('.list-products').on('blur ', '.input-qtd', function (e) {
      jQuery(this).submit();
    })

    jQuery('.main-header .open-drawer').click(function(){
      if( !jQuery('body').hasClass('cart-drawer-open') && $(this).is('span'))
        jQuery('body').addClass('cart-drawer-open cart-open');
    });

    jQuery('.cart-drawer .fallback-text').click(function(){
      if( jQuery('body').hasClass('cart-open') )
        jQuery('body').removeClass('cart-open cart-drawer-open');
    });
  },

  onLoad: function(){
    update_shipping_bar(VastaShop.Cart.current.total_price, VastaShop.Cart.current.item_count);
  },

  onSelect: function() {
    this._run();
  },

  onUnload: function() {
    jQuery('.main-header .open-drawer').off('click');
    jQuery('.cart-drawer .fallback-text').off('click');
    jQuery('.list-products').off('click');
  }
};

return new SectionCartDrawer;
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footer"]) return;
  try {
    
window.SectionFooter = (function(){
  function SectionFooter() {
    this._run();
  }

  SectionFooter.prototype = {
    _run: function() {
      var $menus = $('.site-footer .menu-footer-grid');
      var $titles = $('.site-footer .menu-footer-grid .nav-title');

      function setupFooterMenus() {
        if ($(window).width() < 768) {
          $menus.addClass('clickable');
          $menus.find('.no-bullets').hide();
          $menus.find('.nav-title').removeClass('row-rotate');
        } else {
          $menus.removeClass('clickable');
          $menus.find('.no-bullets').show();
          $menus.find('.nav-title').removeClass('row-rotate');
        }
      }

      setupFooterMenus();

      $(window).off('resize.footerMenus').on('resize.footerMenus', function(){
        setupFooterMenus();
      });

      /* Toggle only when tapping the menu title, not links inside the dropdown. */
      $titles.off('click.footerMenus').on('click.footerMenus', function(e){
        if ($(window).width() < 768) {
          e.preventDefault();
          e.stopPropagation();

          var $currentTitle = $(this);
          var $currentMenu = $currentTitle.closest('.menu-footer-grid');
          var $currentList = $currentMenu.find('.no-bullets').first();
          var isOpen = $currentList.is(':visible');

          $menus.not($currentMenu).find('.no-bullets').stop(true, true).slideUp(180);
          $menus.not($currentMenu).find('.nav-title').removeClass('row-rotate');

          if (isOpen) {
            $currentList.stop(true, true).slideUp(180);
            $currentTitle.removeClass('row-rotate');
          } else {
            $currentList.stop(true, true).slideDown(180);
            $currentTitle.addClass('row-rotate');
          }
        }
      });

      /* Let actual footer links redirect normally. */
      $('.site-footer .menu-footer-grid .no-bullets a')
        .off('click.footerMenusLink')
        .on('click.footerMenusLink', function(e){
          e.stopPropagation();
        });
    },

    onLoad: function() {
      this._run();
    },

    onUnload: function() {}
  };

  return new SectionFooter;
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    

window.SectionHeader = (function(){

  function SectionHeader() {
    this._run();
  }


  SectionHeader.prototype = {

    _run: function() {

      var $window = $(window);
      var $section = $('.bb-header-section').first();
      var $header = $section.find('.bb-site-header').first();
      var $spacer = $section.find('.bb-sticky-spacer').first();
      var stickyStart = 0;


      function desktopShippingOffset() {

        /*
          On mobile the free-shipping bar is part of .bb-site-header,
          so the fixed header always starts at top:0.

          Desktop keeps using the theme's original shipping bar.
          If that original bar is fixed, the header sits below it.
        */
        if ($window.width() <= 767) {
          return 0;
        }

        var $shippingBar = $('#shipping-bar');

        if (
          $shippingBar.length &&
          $shippingBar.is(':visible') &&
          $shippingBar.hasClass('fixed')
        ) {
          return $shippingBar.outerHeight() || 0;
        }

        return 0;

      }


      function refreshStickyStart() {

        if (!$section.length) {
          return;
        }

        /*
          MOBILE HOMEPAGE:
          Do not make the fixed header sit on top of the hero while the
          hero is still on screen. The header becomes sticky only after
          the homepage hero has fully scrolled past.

          This fixes the apparent "cropped banner" issue: the banner
          itself was full-height, but the fixed 102px mobile header was
          covering its top portion.
        */
        if ($window.width() <= 767) {

          var $hero = $('.template-index .bb-hero-slider').first();

          if ($hero.length) {
            stickyStart = $hero.offset().top + $hero.outerHeight();
            return;
          }

        }

        if (
          $section.hasClass('bb-header-fixed') &&
          $spacer.is(':visible')
        ) {
          stickyStart = $spacer.offset().top;
        } else {
          stickyStart = $section.offset().top;
        }

      }


      function updateStickyHeader() {

        if (
          !$section.length ||
          !$header.length
        ) {
          return;
        }

        /*
          MOBILE V18:
          The mobile shipping bar and header are now handled entirely with
          CSS position:sticky on their Shopify SECTION WRAPPERS.

          Do not let the old JS fixed-header system add:
          - position:fixed
          - bb-header-fixed
          - sticky spacers
          on mobile, because those were the source of the hero overlap/crop.
        */
        if ($window.width() <= 767) {

          $section.removeClass('bb-header-fixed');

          $header.css({
            top: '',
            left: '',
            right: '',
            width: ''
          });

          $spacer
            .height(0)
            .hide();

          return;
        }

        var topOffset = desktopShippingOffset();
        var scrollTop = $window.scrollTop();

        if (!stickyStart) {
          refreshStickyStart();
        }

        if (
          scrollTop + topOffset > stickyStart
        ) {

          var headerHeight = $header.outerHeight();

          $spacer
            .height(headerHeight)
            .show();

          $section.addClass('bb-header-fixed');

          $header.css({
            top: topOffset + 'px'
          });

        } else {

          $section.removeClass('bb-header-fixed');

          $header.css({
            top: ''
          });

          $spacer
            .height(0)
            .hide();

          stickyStart = $section.offset().top;

        }

      }


      $(window)
        .off('scroll.bbStickyHeader resize.bbStickyHeader orientationchange.bbStickyHeader')
        .on('scroll.bbStickyHeader', updateStickyHeader)
        .on('resize.bbStickyHeader orientationchange.bbStickyHeader', function(){

          if (!$section.hasClass('bb-header-fixed')) {
            refreshStickyStart();
          }

          updateStickyHeader();

        });


      setTimeout(function(){
        refreshStickyStart();
        updateStickyHeader();
      }, 50);

      /*
        Recalculate once all page images are loaded so the mobile hero's
        true rendered height is used for the sticky threshold.
      */
      $window
        .off('load.bbStickyHeroThreshold')
        .on('load.bbStickyHeroThreshold', function(){
          refreshStickyStart();
          updateStickyHeader();
        });


      /* CART DRAWER */
      $(document)
        .off('click.bbHeaderCart', '.main-header .cart-icon')
        .on('click.bbHeaderCart', '.main-header .cart-icon', function(e){

          if ($(this).hasClass('bb-cart-action')) {
            e.preventDefault();
          }

          if (!$('body').hasClass('cart-drawer-open')) {
            $('body').addClass('cart-drawer-open cart-open');
          }

        });


      $(document)
        .off('click.bbHeaderCartClose', '.cart-drawer .fallback-text')
        .on('click.bbHeaderCartClose', '.cart-drawer .fallback-text', function(){

          if ($('body').hasClass('cart-open')) {
            $('body').removeClass('cart-open cart-drawer-open');
          }

        });



      /* =========================================
         LIVE CART COUNT — V12 DESIGN SAFE

         The legacy theme writes into:
           #cart-count > .count

         That target is now a hidden bridge so legacy
         #cart-count CSS can never distort the visible
         V12 cart icon. We mirror its value into the
         visible .bb-cart-glyph .count.
      ========================================= */

      function setBBVisibleCartCount(count) {

        count = parseInt(count, 10);

        if (isNaN(count)) {
          return;
        }

        $('.bb-cart-glyph > .count').text(count);

      }


      function syncFromLegacyCartBridge() {

        var bridgeCount =
          document.querySelector('#cart-count > .count');

        if (bridgeCount) {
          setBBVisibleCartCount(bridgeCount.textContent);
        }

      }


      var bbLegacyCartCount =
        document.querySelector('#cart-count > .count');

      if (
        bbLegacyCartCount &&
        window.MutationObserver
      ) {

        if (window.__bbHeaderCartCountObserver) {
          try {
            window.__bbHeaderCartCountObserver.disconnect();
          } catch (e) {}
        }

        window.__bbHeaderCartCountObserver =
          new MutationObserver(function(){
            syncFromLegacyCartBridge();
          });

        window.__bbHeaderCartCountObserver.observe(
          bbLegacyCartCount,
          {
            childList: true,
            characterData: true,
            subtree: true
          }
        );

      }


      function refreshBBHeaderCartCount() {

        var root =
          window.Shopify &&
          window.Shopify.routes &&
          window.Shopify.routes.root
            ? window.Shopify.routes.root
            : '/';

        return fetch(root + 'cart.js', {
          method: 'GET',
          headers: {
            'Accept': 'application/json',
            'X-Requested-With': 'XMLHttpRequest'
          }
        })
          .then(function(response){
            return response.json();
          })
          .then(function(cart){

            if (
              cart &&
              typeof cart.item_count !== 'undefined'
            ) {
              $('#cart-count > .count').text(cart.item_count);
              setBBVisibleCartCount(cart.item_count);
            }

            return cart;

          })
          .catch(function(){
            return null;
          });

      }


      $(document)
        .off('ajaxComplete.bbHeaderCartCount')
        .on('ajaxComplete.bbHeaderCartCount', function(event, xhr, settings){

          var url = settings && settings.url
            ? String(settings.url)
            : '';

          if (
            url.indexOf('/cart/add') !== -1 ||
            url.indexOf('/cart/change') !== -1 ||
            url.indexOf('/cart/update') !== -1 ||
            url.indexOf('/cart/clear') !== -1
          ) {
            setTimeout(refreshBBHeaderCartCount, 80);
          }

        });


      [
        'cart:updated',
        'cart:refresh',
        'cart:change',
        'ajaxProduct:added',
        'product:added',
        'monster-cart:refresh',
        'monstercart:refresh',
        'MonsterCart:refresh'
      ].forEach(function(eventName){

        window.addEventListener(eventName, function(){
          setTimeout(refreshBBHeaderCartCount, 60);
        });

        document.addEventListener(eventName, function(){
          setTimeout(refreshBBHeaderCartCount, 60);
        });

      });


      /*
        Catch fetch-based cart additions from apps/custom sections.
      */
      if (!window.__bbHeaderFetchCartPatch && window.fetch) {

        window.__bbHeaderFetchCartPatch = true;

        var bbOriginalFetch = window.fetch;

        window.fetch = function(){

          var fetchArgs = arguments;
          var request = fetchArgs[0];
          var url = '';

          if (typeof request === 'string') {
            url = request;
          } else if (request && request.url) {
            url = request.url;
          }

          return bbOriginalFetch
            .apply(this, fetchArgs)
            .then(function(response){

              if (
                url.indexOf('/cart/add') !== -1 ||
                url.indexOf('/cart/change') !== -1 ||
                url.indexOf('/cart/update') !== -1 ||
                url.indexOf('/cart/clear') !== -1
              ) {
                setTimeout(refreshBBHeaderCartCount, 80);
              }

              return response;

            });

        };

      }


      syncFromLegacyCartBridge();
      refreshBBHeaderCartCount();


      /* SEARCH */
      $(document)
        .off('click.bbHeaderSearch', '.bb-search-toggle')
        .on('click.bbHeaderSearch', '.bb-search-toggle', function(e){

          e.preventDefault();
          e.stopPropagation();

          var $thisHeader = $(this).closest('.bb-site-header');
          var shouldOpen = !$thisHeader.hasClass('bb-search-open');

          $('.bb-site-header').removeClass('bb-search-open');
          $('.bb-search-toggle').attr('aria-expanded', 'false');

          if (shouldOpen) {

            $thisHeader.addClass('bb-search-open');
            $(this).attr('aria-expanded', 'true');

            setTimeout(function(){
              $thisHeader.find('.bb-header-search-input').first().focus();
            }, 50);

          }

        });


      $(document)
        .off('click.bbHeaderSearchClose', '.bb-search-close')
        .on('click.bbHeaderSearchClose', '.bb-search-close', function(e){

          e.preventDefault();

          $(this)
            .closest('.bb-site-header')
            .removeClass('bb-search-open');

          $('.bb-search-toggle')
            .attr('aria-expanded', 'false');

        });


      $(document)
        .off('keydown.bbHeaderSearch')
        .on('keydown.bbHeaderSearch', function(e){

          if (e.keyCode === 27) {

            $('.bb-site-header')
              .removeClass('bb-search-open');

            $('.bb-search-toggle')
              .attr('aria-expanded', 'false');

          }

        });


      /* DRAWER OVERLAY */
      $(document)
        .off('click.bbHeaderOverlay', '.DrawerOverlay')
        .on('click.bbHeaderOverlay', '.DrawerOverlay', function(){

          $('body').removeClass(
            'js-drawer-open-left cart-open cart-drawer-open'
          );

          $('.bb-site-header')
            .removeClass('bb-search-open');

        });


      /* =========================================
         MOBILE LEGACY CLEANUP
         The old theme can still output/reserve space
         for its former mobile search/shipping helpers.
      ========================================= */

      function cleanupLegacyMobileHeader() {

        if ($(window).width() > 767) {
          return;
        }

        $('body .search.mobile, #SearchFormMobile').css({
          display: 'none',
          height: 0,
          minHeight: 0,
          margin: 0,
          padding: 0,
          border: 0,
          overflow: 'hidden'
        });

        $('.height-desck').css({
          display: 'none',
          height: 0,
          minHeight: 0,
          margin: 0,
          padding: 0
        });

        $('.shippingbar_padding').css({
          paddingTop: 0,
          marginTop: 0
        });

        $('.template-index .main-content, .template-index .bb-hero-slider').css({
          marginTop: 0,
          paddingTop: 0
        });

      }

      cleanupLegacyMobileHeader();

      $(window)
        .off('resize.bbLegacyCleanup orientationchange.bbLegacyCleanup')
        .on('resize.bbLegacyCleanup orientationchange.bbLegacyCleanup', cleanupLegacyMobileHeader);


      /* =========================================
         HOMEPAGE HERO FIRST-PAINT PROTECTION

         Do not move the slider or change scrollLeft here.
         We only reveal all slides after the browser has
         completed the first paint. CSS keeps non-first
         slides hidden for that tiny initial moment.
      ========================================= */

      function markHeroReady() {

        requestAnimationFrame(function(){
          $('.bb-hero-slider').addClass('bb-hero-ready');
        });

      }

      markHeroReady();

      $(window)
        .off('pageshow.bbHeroFix')
        .on('pageshow.bbHeroFix', markHeroReady);

    },


    onSelect: function() {
      this._run();
    },


    onUnload: function() {

      $(window).off('.bbStickyHeader');

      $(document).off('.bbHeaderCart');
      $(document).off('.bbHeaderCartClose');
      $(document).off('.bbHeaderCartCount');
      $(document).off('.bbHeaderSearch');
      $(document).off('.bbHeaderSearchClose');
      $(document).off('.bbHeaderOverlay');

    }

  };


  return new SectionHeader;

})();


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["instafeed"] && !Shopify.designMode) return;
  try {
    
function formatInstagramDate( image ) {
    var monthNames,
        date = new Date(image.created_time * 1000);

    m = date.getMonth();
    d = date.getDate();
    y = date.getFullYear();

    monthNames = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];

    image.created_time = monthNames[m] + ' ' + d + ', ' + y;

    return true;
}

window.SectionInstafeed = (function(){
    function SectionInstafeed() {
        this.section = null;
        this.data = null;

        this._run();
    }

    function getResolution( data ) {
        return (jQuery(window).width() < 767 || data.image_per_row > '4') ? 'low_resolution' : 'standard_resolution';
    }

    function newInstafeed( data, resolution, limitphoto ) {
        return new Instafeed({
            get: 'user',
            userId: 'self',
            accessToken: data.access_token,
            sortBy: 'most-recent',
            limit: limitphoto,
            resolution: resolution,
            template: data.template,

            after: function() {
                var images = $('.instagram__image-wrapper');
    
                images.filter(':nth-child(2n + 1)').addClass('grid__item--mobile-first');
                images.filter(':nth-child(' + data.image_per_row + 'n + 1)').addClass('grid__item--tablet-first grid__item--desktop-first');
            },
            
            filter: $.proxy(formatInstagramDate)
        });
    }

    function runInstafeed( data ) {
        var resolution, limitphoto;

        if (data.access_token) {
            resolution = getResolution( data ) ;

            if(jQuery(window).width() < 767) {
                limitphoto = 7;
            } else {
                limitphoto = (data.rows * data.image_per_row) + 1;

                var feed = newInstafeed( data, resolution, limitphoto );
            
                feed.run();
            }
        }
    }

    SectionInstafeed.prototype = {
        _run: function() {
            this.section = document.querySelector('[data-section-type="instafeed"]');

            this.data = {
                access_token: this.section.getAttribute('data-access-token'),
                rows: this.section.getAttribute('data-rows'),
                image_per_row: this.section.getAttribute('data-image-per-row'),
                template: '<div class="instagram__image-wrapper"><a href="{{link}}" id="{{id}}" target="_blank"><div class="instagram__overlay"><p class="instagram__caption">{{caption}}</p><time class="instagram__date">{{model.created_time}}</time></div><img loading="lazy" class="instagram__image lazy" src="{{image}}" data-src="{{image}}"/></a></div>'
            };

            runInstafeed( this.data );
        },

        onSelect: function() {
            this._run();
        },
    };

    return new SectionInstafeed;
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["menu-mobile"]) return;
  try {
    

(function($){

  function openDrawer() {
    $('.main-content').addClass('is-moved-by-drawer');
    $('.fixed').addClass('is-moved-by-drawer');
    $('.shopify-section header').addClass('is-moved-by-drawer');
    $('body').addClass('js-drawer-open-left');
  }

  function closeDrawer() {
    $('body').removeClass('js-drawer-open-left');
    $('.main-content').removeClass('is-moved-by-drawer');
    $('.fixed').removeClass('is-moved-by-drawer');
    $('.shopify-section header').removeClass('is-moved-by-drawer');
  }

  $(document)
    .off('click.bbMobileOpen', '#IconMenuTextMobile')
    .on('click.bbMobileOpen', '#IconMenuTextMobile', function(e){
      e.preventDefault();
      openDrawer();
    });

  $(document)
    .off('click.bbMobileClose', '.js-drawer-close, .DrawerOverlay')
    .on('click.bbMobileClose', '.js-drawer-close, .DrawerOverlay', function(e){
      e.preventDefault();
      closeDrawer();
    });

  /*
    V31 ACCORDION CONTROL

    Use a native CAPTURE-PHASE listener so our drawer handles the click
    BEFORE any legacy theme bubbling handlers can run.

    Both:
      - clicking the menu text
      - clicking the + / − button
    call the exact same toggle function and update aria-expanded + symbol.
  */

  function bbToggleDrawerRow(row) {

    if (!row) return;

    var button = row.querySelector('.bb-drawer-toggle');
    var child = row.nextElementSibling;

    if (
      !button ||
      !child ||
      !child.classList.contains('child')
    ) {
      return;
    }

    var isOpen = button.getAttribute('aria-expanded') === 'true';
    var willOpen = !isOpen;
    var symbol = button.querySelector('.bb-drawer-plus');

    button.setAttribute('aria-expanded', willOpen ? 'true' : 'false');
    button.classList.toggle('is-open', willOpen);

    if (symbol) {
      symbol.textContent = willOpen ? '−' : '+';
    }

    if (willOpen) {
      $(child).stop(true, true).slideDown(240);
    } else {
      $(child).stop(true, true).slideUp(240);
    }

  }


  if (window.__bbDrawerAccordionCaptureHandler) {
    document.removeEventListener(
      'click',
      window.__bbDrawerAccordionCaptureHandler,
      true
    );
  }


  window.__bbDrawerAccordionCaptureHandler = function(event) {

    var target = event.target.closest(
      '.bb-mobile-drawer .bb-drawer-toggle, ' +
      '.bb-mobile-drawer .bb-drawer-parent-link'
    );

    if (!target) return;

    var drawer = target.closest('.bb-mobile-drawer');

    if (!drawer) return;

    var row = target.closest('.button-menu-item');

    if (!row) return;

    event.preventDefault();
    event.stopPropagation();

    if (typeof event.stopImmediatePropagation === 'function') {
      event.stopImmediatePropagation();
    }

    bbToggleDrawerRow(row);

  };


  document.addEventListener(
    'click',
    window.__bbDrawerAccordionCaptureHandler,
    true
  );

})(jQuery);


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-tabs"]) return;
  try {
    
(function($){
    var $document = $(document);

    $document.ready(function(){
        $document.on('click', '.tabs', function(){
            var tabs = $(this),
                scope = tabs.parent().attr('data-tabs-scope');

            tabs.addClass('active').siblings().removeClass('active');

            $('.tabs-content[data-tabs-scope="' + scope + '"] .tab-content[data-identifier="' + tabs.attr('data-target') + '"]').addClass('active').siblings().removeClass('active');

            return false;
        });
    });
})(jQuery);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["reviews"] && !Shopify.designMode) return;
  try {
    
window.SectionReviews = (function(){
  function SectionReviews() {
    this.settings = {
      slidesToShow: 3,
      slidesToScroll: 1,
      autoplay: true,
      autoplaySpeed: 2000,
      arrows: false,
      responsive: [
          {
            breakpoint: 1280,
            settings: {
              slidesToShow: 3,
              slidesToScroll: 1,
            }
          },
          {
            breakpoint: 1019,
            settings: {
              slidesToShow: 3,
              slidesToScroll: 1
            }
          },
          {
              breakpoint: 767,
              settings: {
                slidesToShow: 1,
                slidesToScroll: 1,
              }
          }
      ]
    };

    this._run();
  }

  SectionReviews.prototype = {
    onLoad: function() {
      this._run();
    },

    _run: function() {
      var slider, autoplay, autoplaySpeed,
          settings = this.settings;

      jQuery('[id^="slider-reviews-"]').each(function(){
        slider = '#slider-' + $(this).data('slider');

        autoplay = jQuery(slider).data('autoplay');
        autoplaySpeed = jQuery(slider).data('speed');

        if (typeof autoplay !== 'undefined' && autoplay != true && autoplay != false) {
          autoplay = true;
        }

        if (typeof autoplaySpeed !== 'undefined' && autoplaySpeed < 800 && autoplaySpeed > 3000) {
          autoplaySpeed = 800;
        }

        settings.autoplay = autoplay;
        settings.autoplaySpeed = autoplaySpeed;

        jQuery(slider).not('.slick-initialized').slick( settings );
      });
    }
  };

  return new SectionReviews;
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["shipping_bar"]) return;
  try {
    
window.SectionShippingBar = (function(){
  function SectionShippingBar() {
    this._run();
  }

  SectionShippingBar.prototype = {
    _run: function() {

    },

    onSelect: function() {
      this._run();
    },

    onUnload: function() {

    }
  };

  return new SectionShippingBar;
  })();
  

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["slider-promotional"] && !Shopify.designMode) return;
  try {
    
window.SectionSliderPromotional = (function(){
  function SectionSliderPromotional() {
    this.settings = {
      slidesToShow: 4,
      slidesToScroll: 1,
      autoplay: true,
      autoplaySpeed: 2000,
      prevArrow: '<button type="button" class="slick-prev">&lang;</button>',
      nextArrow: '<button type="button" class="slick-next">&rang;</button>',
      arrows: true,
      responsive: [
          {
              breakpoint: 1180,
              settings: {
                slidesToShow: 4,
                slidesToScroll: 1,
              }
          },
          {
              breakpoint: 1019,
              settings: {
                slidesToShow: 3,
                slidesToScroll: 1,
              }
          },
          {
              breakpoint: 767,
              settings: {
                slidesToShow: 2,
                slidesToScroll: 1,
              }
          }
      ]
    };

    this._run();
  }

  SectionSliderPromotional.prototype = {
    onLoad: function() {
      this._run();
    },

    _run: function() {
      var slider, autoplay, autoplaySpeed, settings = this.settings;

      jQuery('[id^="slider-promotional-"]').each(function(){
        slider = '#promotional-' + $(this).data('slider');
        
        autoplay = jQuery(slider).data('autoplay');
        autoplaySpeed = jQuery(slider).data('speed');

        if (typeof autoplay !== 'undefined' && autoplay != true && autoplay != false) {
          autoplay = true;
        }

        if (typeof autoplaySpeed !== 'undefined' && autoplaySpeed < 800 && autoplaySpeed > 3000) {
          autoplaySpeed = 800;
        }

        settings.autoplay = autoplay;
        settings.autoplaySpeed = autoplaySpeed;
        
        jQuery(slider).not('.slick-initialized').slick( settings );
      });
    }
  };

  return new SectionSliderPromotional;
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["videos"] && !Shopify.designMode) return;
  try {
    

window.SectionVideoSlider = (function(){
  function SectionVideoSlider() {
    this.settings = {
      slidesToShow: 1,
      slidesToScroll: 1,
      prevArrow: '<button type="button" class="slick-prev">&lang;</button>',
      nextArrow: '<button type="button" class="slick-next">&rang;</button>',
      infinite: true
    };

    this._run();
  }

  SectionVideoSlider.prototype = {
    onLoad: function() {
      this._run();
    },

    _run: function() {
      var slider,
          settings = this.settings;

      jQuery('[id^="video-slider-"]').each(function(){
        slider = '#slider-' + $(this).data('slider');

        jQuery(slider).not('.slick-initialized').slick( settings );
      });
    }
  };

  return new SectionVideoSlider;
})();


  } catch(e) { console.error(e); }
})();
})();
